module.exports = __webpack_public_path__ + "img/address.a4c5032a.png";